import classnames from 'classnames';
import { useTranslation } from 'react-i18next';
import { useGetReferralCode } from '@/query/queries/marketing/useGetReferralCode';
import { AFFILIATE_STEPS } from '../data';
import s from './index.module.scss';

export const AffiliateStepsMobile = props => {
  const { t } = useTranslation('affiliate');
  const { data: referralCode } = useGetReferralCode();
  const isActiveReferralBanner = !!referralCode?.is_referral_banner_active;

  return (
    <div className={classnames(s.wrapper, props.className)}>
      <div className={s.steps}>
        {AFFILIATE_STEPS(t).map((item, index) => (
          <div key={item.label} className={s.step}>
            <div className={s.step_number}>
              <div className={s.step_num}>0{index + 1}</div>
            </div>
            <div className={s.step_content}>
              <div className="f-18 f-500">{item.label}</div>
              <div className={classnames(s.desc, 'f-16 f-400')}>
                {item.desc}
              </div>
              {isActiveReferralBanner && item.banner}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};
